import { PlannerApi } from '../planner.api';
import type { ApiResponse, PlannerLabel, PlannerTaskLabel } from '@vision/ui/interfaces';
import type {
  PlannerLabelsArgs,
  PlannerLabelCreateArgs,
  PlannerTaskLabelCreateArgs,
  PlannerTaskLabelDeleteArgs,
} from './task-labels.api.types';
import {
  buildGetLabelsRequest,
  buildCreateLabelRequest,
  buildCreateTaskLabelRequest,
  buildDeleteTaskLabelRequest,
} from './task-labels.routes';

export const PlannerTaskLabelEndpoints = PlannerApi.injectEndpoints({
  endpoints: (builder) => ({
    getLabels: builder.query<ApiResponse<PlannerLabel[]>, PlannerLabelsArgs>({
      query: buildGetLabelsRequest,
    }),
    createLabel: builder.mutation<ApiResponse<PlannerLabel>, PlannerLabelCreateArgs>({
      query: buildCreateLabelRequest,
    }),
    createTaskLabel: builder.mutation<ApiResponse<PlannerTaskLabel>, PlannerTaskLabelCreateArgs>({
      query: buildCreateTaskLabelRequest,
    }),
    deleteTaskLabel: builder.mutation<ApiResponse<PlannerTaskLabel>, PlannerTaskLabelDeleteArgs>({
      query: buildDeleteTaskLabelRequest,
    }),
  }),
});

export const { useLazyGetLabelsQuery, useCreateLabelMutation, useCreateTaskLabelMutation, useDeleteTaskLabelMutation } =
  PlannerTaskLabelEndpoints;
